<div class="support-menu">
  <!-- Slide-out menu panel — each item is an icon in a circle with a tooltip -->
  <div class="support-menu__items" [class.support-menu__items--open]="isOpen()">
    @for (item of visibleItems(); track item.action) {
      <button
        type="button"
        class="support-menu__item"
        [disabled]="item.state.status === 'disabled'"
        [matTooltip]="item.state.unavailableTooltip ?? item.label"
        [attr.aria-label]="item.label"
        matTooltipPosition="left"
        (click)="handleAction(item.action)"
      >
        <rx-icon [name]="item.icon" class="dark"></rx-icon>
      </button>
    }
  </div>

  <!-- Menu toggle button -->
  <button
    type="button"
    class="support-menu__toggle"
    [class.support-menu__toggle--open]="isOpen()"
    [matTooltip]="isOpen() ? '' : 'Support'"
    matTooltipPosition="left"
    (click)="toggle()"
    aria-label="Support menu"
  >
    <rx-icon name="question-mark" class="white"></rx-icon>
  </button>
</div>
